import React, { useState } from "react";
import OptionsSelector, { OptionType } from "../../components/OptionsSelector";
import { View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import { BodyMediumText } from "../../components/FormattedText";
import type { Meta, StoryObj } from "@storybook/react";

const ComponentStory = ({ disabled }: { disabled: boolean }) => {
    const [value, setValue] = useState("option1");
    const [value2, setValue2] = useState("option1");
    const [value3, setValue3] = useState("option1");
    const [value4, setValue4] = useState(false);

    const data: [OptionType<string>, OptionType<string>] = [
        { value: "option1", label: "Option 1" },
        { value: "option2", label: "Option 2" },
    ];

    const data2: [OptionType<string>, OptionType<string>] = [
        { value: "option1", label: "This is a long text" },
        { value: "option2", label: "Option 2" },
    ];

    const data3: [OptionType<string>, OptionType<string>] = [
        { value: "option1", label: "This is a long text", badge: "1" },
        { value: "option2", label: "Option 2", badge: "20" },
    ];

    const data4: [OptionType<boolean>, OptionType<boolean>] = [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
    ];

    return (
        <VStack gap={1} alignment="stretch" style={{ width: "100%" }}>
            <OptionsSelector data={data} disabled={disabled} value={value} onSelect={setValue} />
            <BodyMediumText>{value}</BodyMediumText>
            <OptionsSelector data={data2} disabled={disabled} value={value2} onSelect={setValue2} />
            <BodyMediumText>{value2}</BodyMediumText>
            <OptionsSelector
                data={data3}
                disabled={disabled}
                value={value3}
                onSelect={setValue3}
                showCheckIcon={false}
            />
            <BodyMediumText>{value3}</BodyMediumText>
            <OptionsSelector
                data={data4}
                disabled={disabled}
                value={value4}
                onSelect={setValue4}
                shrinked
            />
            <BodyMediumText>{value4.toString()}</BodyMediumText>
        </VStack>
    );
};

const meta = {
    title: "Components/Options",
    component: ComponentStory,
    argTypes: {
        disabled: {
            control: { type: "boolean" },
        },
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {
        disabled: false,
    },
};
